import { Images as ABCyaImages, Audio as ABCyaAudio, Tweens as ABCyaTweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class BlobRotate extends Phaser.GameObjects.Container {

  constructor (scene, row, col, direction) {
    super(scene);

    /*  direction1,
         actionDirection1:
         -1 - None,
         0 - Up,
         1 - Right,
         2 - Down,
         3 - Left,
         6 - All.
         */

    this.name = 'BlobRotate';
    this.row = row;
    this.column = col;
    this.direction = direction;
    this.enabled = true;
    this.movable = true;

    this.sprite = this.scene.add.sprite(0, 0, ABCyaImages.DEFAULT_ATLAS, UIAssetKeys._greenSheet_greenSheet_0);
    this.add(this.sprite);

    this.scene.time.addEvent({ delay: 4400,
      loop: true,
      callback: () => {
        this.sprite.setFrame(UIAssetKeys._greenSheet_greenSheet_1);
        this.scene.time.delayedCall(400, () => {this.sprite.setFrame(UIAssetKeys._greenSheet_greenSheet_0);});
      } });

    this.setScale(0.78);

    this.sprite.setInteractive({ pixelPerfect: true });

    this.sprite.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
      if (!this.enabled) return;
      if (!this.parentContainer.checkRotateBlock(this)) return;

      this.enabled = false;

      this.parentContainer.rotateBlock(this);
      ABCyaAudio.playOneShot('Rotate_Blob', this.scene);

      ABCyaTweens.addTween(this, 800, { angle: 360 }, Phaser.Math.Easing.Sine.Out, () => { this.enabled = true;});

    });
  };
}